// utils/getPolizzaEliminata.ts
import { supabase } from '../supabaseClient';

type Agenzia = { nome: string } | null;
type Agente = { nome: string; cognome: string; agenzia: Agenzia } | null;

export type PolizzaEliminata = {
  id: string;
  numero_polizza: string | null;
  targa: string | null;
  nome_cliente: string | null;
  cognome_cliente: string | null;
  ragione_sociale: string | null;
  codice_fiscale: string | null;
  partita_iva: string | null;
  deleted_at: string;
  agente: Agente;
};

export async function getPolizzaEliminata(id: string): Promise<PolizzaEliminata> {
  // 🔹 Primo step: recupera la polizza eliminata + id_agente
  const { data: polizza, error } = await supabase
    .from('polizze_eliminate')
    .select(`
      id,
      numero_polizza,
      targa,
      nome_cliente,
      cognome_cliente,
      ragione_sociale,
      codice_fiscale,
      partita_iva,
      deleted_at,
      id_agente
    `)
    .eq('id', id)
    .single();

  if (error || !polizza) throw new Error('Polizza eliminata non trovata');

  let agente: Agente = null;

  // 🔹 Secondo step: se presente, recupera agente + agenzia
  if (polizza.id_agente) {
    const { data: agenteData } = await supabase
      .from('utenti')
      .select(`
        nome,
        cognome,
        agenzia:agenzie ( nome )
      `)
      .eq('id', polizza.id_agente)
      .single();

    if (agenteData) {
      const agenzia = Array.isArray(agenteData.agenzia)
        ? agenteData.agenzia[0] ?? null
        : agenteData.agenzia ?? null;

      agente = {
        nome: agenteData.nome,
        cognome: agenteData.cognome,
        agenzia,
      };
    }
  }

  return {
    ...polizza,
    agente,
  };
}
